export const firebaseConfig = {
  apiKey: "AIzaSyCl2ZL7tX9BGMHK18m3PNjRaMMY-AeRN_s",
  authDomain: "works-52666.firebaseapp.com",
  projectId: "works-52666",
  storageBucket: "works-52666.appspot.com",
  messagingSenderId: "811896829814",
  appId: "1:811896829814:web:3efcd91ca06aca4eabec57",
  measurementId: "G-VBRD2RVXST"
};
